import { createAsyncThunk } from "@reduxjs/toolkit";
import { address_list } from "../../../../api/calls/user/address_list";
import { setMainModal } from "../../main";
import { setUser } from "../../user";
import { setAddressList } from "../address";
export const getAddressListThunk = createAsyncThunk("address/get_address_list_thunk", async (arg, { dispatch, getState }) => {
    const state = getState();
    const { user } = state.userState;
    const response = await address_list({
        user_id: user?.user._id,
    });
    if (response.success) {
        if (!!response.content) {
            const firstAddress = response.content?.[0];
            dispatch(setAddressList(response.content));
            dispatch(setUser({ ...user, address: firstAddress }));
        }
    }
    else {
        dispatch(setMainModal({ title: "Something went wrong while getting your address-list!", messages: [response.message] }));
    }
    return response;
});
